import * as Sentry from '@sentry/react';

// Ignore errors originating from injected scripts
// https://github.com/getsentry/sentry-javascript/issues/3147
function isInjectedCode(event: Sentry.Event | undefined): boolean {
  const frames = event?.exception?.values?.[0]?.stacktrace?.frames;

  if (!frames || frames.length === 0) return false;

  const [firstFrame] = frames;
  if (
    firstFrame.filename === '<anonymous>' ||
    firstFrame.filename?.startsWith('chrome-extension://')
  ) {
    return true;
  }

  const lastFrame = frames[frames.length - 1];
  if (
    lastFrame.filename === window.location.pathname ||
    lastFrame.filename?.startsWith(window.location.origin)
  ) {
    return true;
  }

  const filenames = frames
    .map(f => f.filename)
    .filter((file): file is string => !!file);

  // Google tag manager
  if (filenames.some(f => f.includes('gtm.js'))) {
    return true;
  }
  // One trust SDK
  if (filenames.some(f => f.includes('scripttemplates/otSDKStub'))) {
    return true;
  }

  return false;
}

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://5e19a123dac252496849ae14aec09d2e@o483267.ingest.us.sentry.io/4507883936153600',
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/connect\.treatwell\..*/],

    beforeSend(event) {
      if (isInjectedCode(event)) {
        return null;
      }
      return event;
    },
  });
};
